const ModifyCardModalStyle = {
    TitleStyles:{ textAlign: "center" },
    MenuStyles:{ width: "100%" },
    SubMenuStyles:{ padding: "10px" },
    ButtonStyles:{ marginTop: "10px" }
}
export {ModifyCardModalStyle}